import {Component, Input, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {UserImageComponent} from '../../../../core/components/user-image/user-image.component';
import {User} from '../../../../core/entities/user/user.entity';
import {TranslocoPipe} from '@jsverse/transloco';
import {getTagIconFromLabel} from '../../../../core/entities/photography/photography-tag.entity';
import {CurrencyPipe} from '@angular/common';

@Component({
  selector: 'app-onboarding-preview',
  templateUrl: './onboarding-preview.html',
  standalone: true,
  imports: [
    UserImageComponent,
    TranslocoPipe,
    CurrencyPipe
  ],
  styleUrl: './onboarding-preview.scss'
})
export class OnboardingPreview implements OnChanges, OnDestroy {
  @Input() step!: number;
  @Input() profileForm: FormGroup|null = null;
  @Input() serviceForm: FormGroup|null = null;
  @Input() serviceImage: Blob|null = null;
  @Input() user: User|null = null; // for the picture
  protected readonly getTagIconFromLabel = getTagIconFromLabel;

  // Preview URL generated from the File
  serviceImageUrl: string | null = null;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['serviceImage']) {
      // Revoke previous URL to prevent memory leaks
      if (this.serviceImageUrl) {
        URL.revokeObjectURL(this.serviceImageUrl);
        this.serviceImageUrl = null;
      }
      // Create a new object URL when a File is provided
      if (this.serviceImage instanceof File) {
        this.serviceImageUrl = URL.createObjectURL(this.serviceImage);
      }
    }
  }

  ngOnDestroy() {
    if (this.serviceImageUrl) {
      URL.revokeObjectURL(this.serviceImageUrl);
    }
  }
}
